import Navbar, { getHtmlClasses } from './navbar';
import './navbar.sass';

export default Navbar;

export { getHtmlClasses };
